import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAdminSlice, TAdminPage } from "@/redux/slices/admin/types";
import { getAdminPageByUuid } from "@/lib/api-server/admin/page/getAdminPageByUuid";

export const getPage = createAsyncThunk(
  "admin/getPage",
  async (uuid: string, { rejectWithValue }) =>
    // use server
    await getAdminPageByUuid(uuid).then((r) => {
      if (r.success)
        return {
          ...r.data,
        };
      if (!r.success) return rejectWithValue((r as any).error);
    })
);

const pending = (state: IAdminSlice, { meta }: { meta: { arg: string } }) => {
  state.pages = state.pages.map((page) => {
    if (page.uuid === meta.arg) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
  state.loading = true;
};

const rejected = (state: IAdminSlice, { meta }: { meta: { arg: string } }) => {
  state.pages = state.pages.map((page) => {
    if (page.uuid === meta.arg) {
      return {
        ...page,
        loading: false,
      };
    }
    return page;
  });
  state.loading = false;
};

const fulfilled = (
  state: IAdminSlice,
  { payload, meta }: { payload: TAdminPage; meta: { arg: string } }
) => {
  state.pages = state.pages.map((page) => {
    if (page.uuid === meta.arg) {
      return {
        ...page,
        ...payload,
        loading: false,
      };
    }
    return page;
  });
  state.loading = false;
};

export default {
  action: getPage,
  pending,
  rejected,
  fulfilled,
};
